var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDollarSign = function SvgDollarSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.205 7.546c-1.934-.71-2.729-1.172-2.729-1.897 0-.618.476-1.237 1.955-1.237.814 0 1.478.126 2.017.283a1.33 1.33 0 0 0 1.003-.111 1.26 1.26 0 0 0 .613-.775l.004-.019c.18-.683-.24-1.382-.944-1.561a9.906 9.906 0 0 0-2.056-.286V1.08c0-.595-.5-1.08-1.113-1.08-.614 0-1.113.485-1.113 1.08v1.015C1.408 2.557 0 4.08 0 6.023c0 2.141 1.66 3.244 4.09 4.038 1.683.554 2.41 1.08 2.41 1.92 0 .882-.885 1.366-2.182 1.366a7.904 7.904 0 0 1-2.454-.408 1.368 1.368 0 0 0-1.054.084 1.278 1.278 0 0 0-.649.809l-.004.02c-.18.686.22 1.388.917 1.602.774.24 1.706.409 2.654.45v1.016c0 .595.5 1.08 1.113 1.08s1.113-.485 1.113-1.08v-1.168C8.569 15.309 10 13.634 10 11.672c0-1.989-1.093-3.203-3.795-4.126",
    fill: "#C2C6D5",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollarSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar-sign.3338c1e9.svg";
export { ForwardRef as ReactComponent };